import { pluralize, pluralizeWithCount } from "@common/helpers/string";
import { BulkScheduleNoun } from "./bulkScheduleRows";

export function getBulkScheduleConfirmLabel(noun: BulkScheduleNoun): string {
    return noun === "schedule" ? "Move schedules" : "Replace schedules";
}

export function formatBulkScheduleBlockedSubject(options: {
    noun: BulkScheduleNoun;
    count: number;
}): string {
    if (options.noun !== "schedule") {
        return `These ${pluralize(options.noun, options.count)} can't be scheduled`;
    }
    const determiner = options.count === 1 ? "this" : "these";
    return `Couldn't move ${determiner} ${pluralize("schedule", options.count)}`;
}

export function formatBulkScheduleAppliedLabel(options: {
    noun: BulkScheduleNoun;
    scheduleName: string;
    appliedCount: number;
}): string {
    const rows = pluralizeWithCount(options.noun, options.appliedCount);
    return options.noun === "schedule"
        ? `Moved ${rows} to ${options.scheduleName}`
        : `${options.scheduleName} applied to ${rows}`;
}

export function formatBulkScheduleAllFailedLabel(options: {
    noun: BulkScheduleNoun;
    scheduleName: string;
    count: number;
    reason: string | undefined;
}): string {
    const base =
        options.noun === "schedule"
            ? `Couldn't move ${pluralizeWithCount("schedule", options.count)} to ${options.scheduleName}`
            : `${options.scheduleName} couldn't be applied`;
    return options.reason ? `${base}: ${options.reason}` : base;
}

export function formatBulkScheduleFailedLabel(options: {
    noun: BulkScheduleNoun;
    failedCount: number;
}): string {
    const rows = pluralizeWithCount(options.noun, options.failedCount);
    return options.noun === "schedule"
        ? `${rows} couldn't be moved`
        : `${rows} couldn't be scheduled`;
}
